import Vue from 'vue'
import App from './App.vue'

import VueCarousel from 'vue-carousel';
import Router from './Routes.js'

import { library } from '@fortawesome/fontawesome-svg-core';
import {fas} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';


//vue bootstrap

// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// // Import Bootstrap an BootstrapVue CSS files (order is important)
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

// // Make BootstrapVue available throughout your project
// Vue.use(BootstrapVue)
// // Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin)






library.add(fas);
Vue.component('font-awesome-icon' ,FontAwesomeIcon);
//Sweet Alart
import VueSwal from 'vue-swal'
Vue.use(VueSwal)

Vue.use(VueCarousel);
 


new Vue({
  el: '#app',
  router:Router,
  render: h => h(App)
 
})
